/* eslint-disable react/prop-types */
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { useState } from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { ControlLabel, FormGroup } from 'react-bootstrap';
import Modal from '../utils/ModalComponet';
import ActivitiesAutoComplete from '../utils/AutoComplete/ActivitiesAutoComplete';

const BookingOptionsAppendForm = ({ closeModal, onSave }) => {
  const [selectedActivityId, setSelectedActivityId] = useState<string | null>(
    null
  );

  return (
    <Modal
      open
      closeModal={closeModal}
      cancel={closeModal}
      action={() => onSave(selectedActivityId)}
      actionButtonText='Save'
      disabled={!selectedActivityId}
    >
      <FormGroup>
        <ControlLabel>Activity</ControlLabel>
        <ActivitiesAutoComplete onSelect={setSelectedActivityId} />
      </FormGroup>
    </Modal>
  );
};

export default BookingOptionsAppendForm;
